module.exports = __webpack_public_path__ + "img/american-express-dark.74f6dac1.svg";